var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 18C4.75 17.5858 4.41421 17.25 4 17.25C3.58579 17.25 3.25 17.5858 3.25 18V21C3.25 21.9665 4.0335 22.75 5 22.75H19C19.9665 22.75 20.75 21.9665 20.75 21V18C20.75 17.5858 20.4142 17.25 20 17.25C19.5858 17.25 19.25 17.5858 19.25 18V21C19.25 21.1381 19.1381 21.25 19 21.25H5C4.86193 21.25 4.75 21.1381 4.75 21V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.50002C6.25 5.19668 6.06727 4.9232 5.78701 4.80711C5.50676 4.69103 5.18417 4.75519 4.96967 4.96969L1.46967 8.46969C1.17678 8.76259 1.17678 9.23746 1.46967 9.53035L4.96967 13.0304C5.18417 13.2449 5.50676 13.309 5.78701 13.1929C6.06727 13.0768 6.25 12.8034 6.25 12.5V9.75002H10C10.6904 9.75002 11.25 10.3097 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 9.48124 11.5188 8.25002 10 8.25002H6.25V5.50002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlt);
export default __webpack_public_path__ + "static/media/share-alt.6755ed2045358f98529a09d335c50892.svg";
export { ForwardRef as ReactComponent };